import { render, staticRenderFns } from "./w-button-boxes.vue?vue&type=template&id=ad16be18"
import script from "./w-button-boxes.vue?vue&type=script&lang=js"
export * from "./w-button-boxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports